module.exports = __webpack_public_path__ + "static/img/newFour.cc734e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/earnImg/newFour.png
// module id = ikcM
// module chunks = 1